import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ls from 'local-storage';
import PhoneInput from 'react-phone-number-input/input';

import API from "../../../Services/BaseService";
import StateAndCity from '../../../Component/StateAndCity/StateAndCity'
import CommonPopup from '../../../Component/CommonPopup/CommonPopup';
import ManageAccountLinks from "../../../Component/ManageAccountLinks/ManageAccountLinks"
import appstore from '../../../assets/img/appstore.png';
import googleplay from '../../../assets/img/googleplay.png';
import adduser from '../../../assets/img/adduser.jpg';
import LoginActions from '../../Login/LoginAction'
import PhoneInputs from 'react-phone-input-2'
import Loading from '../../../Component/Loading/Loading';
import PageNotFound from '../../FallBackUI/PageNotFound';

const EditSeller = (props) => {
    const history = useHistory();
    const { id, sellerDealer, sellerRequest } = props.location.state;
    console.log("idtesting", id)
    const [myProfileObjc, setMyProfileObj] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [primaryPhone, setPrimaryPhone] = useState([]);
    const [mobilePhone, setMobilephone] = useState("");
    const [phoneNo, setPhoneNo] = useState("");
    const [emailId, setEmailId] = useState("");
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [sslNo, setSslno] = useState("");

    const [city, setCity] = useState(null);
    const [state, setState] = useState(null);
    const [zipcode, setZipcode] = useState(null);
    const [locationName, setLocationName] = useState("");
    const [privileges_id, setPriviegesId] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [doc, setDoc] = useState("");
    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("");
    const [image, setImage] = useState("");
    const [selectPrivilege, setselectPrivilege] = useState(false)
    const [deselectPrivilege, setDeselectPrivilege] = useState(false)
    const [privilegesObj, setPrivilegesObj] = useState({})
    const [primaryPhoneError, setPrimaryPhoneError] = useState("");
    const [mobilePhoneError, setMobilephoneError] = useState("");
    const [addressError, setAddressError] = useState("");
    const [locationNameError, setLocationNameError] = useState("");
    const [stateAndCityError, setStateAndCityError] = useState("")
    const [isPrivileges, setIsPrivileges] = useState(false)
    const [type, setType] = useState("");
    const [post_car, setPost_car] = useState(0);
    const [remove_car, setRemove_car] = useState(0);
    const [create_user, setCreate_user] = useState(0);
    const [counter_bid, setCounter_bid] = useState(0);
    const [user, setUser] = useState(0);

    const [option, setOption] = useState("");
    const [loading, setLoading] = useState(true);

    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);
    const [status, setStatus] = useState("");
    const [statusStanding, setStatusStanding] = useState("");
    const [sellerId, setSellerId] = useState("")
    const [statusColor, setStatusColor] = useState("")
    const [selectedStatus, setSelectedStatus] = useState("");
    const dispatch = useDispatch();
    const sellerDetails = useSelector(state => state.LoginReducer.payload);
    console.log("==sellerDetails==", sellerDetails)




    const getStateName = (stateData) => {
        setState(stateData)
    }

    const getCityName = (cityData) => {
        setCity(cityData)
    }

    const getZipCodeId = (zipData) => {
        setZipcode(zipData)
    }
    // useEffect(() => {
    //     DataStatus();
    //     // handlestatus();
    // }, [])

    useEffect(() => {
        let request = {
            seller_id: id,
            seller_dealer_id: sellerDealer,
            seller_request_id: sellerRequest == null ? "" : sellerRequest,
            seller_token: sellerDetails.seller_token,
            token_seller_id: sellerDetails.seller_id
        };
        const state = API.post('seller_details/condition', request);
        state.then(res => {
            console.log("sellerDetails=>", sellerDetails)
            console.log("res=>", res.data.data)
            if (res.data.success === true) {
                setFirstName(res.data.data[0].first_name);
                setLastName(res.data.data[0].last_name);
                setSelectedStatus(res.data.data[0].standing)
                // setPrimaryPhone(res.data.data[0].phone_no);
                // setMobilephone(res.data.data[0].mobile_no);
                setEmailId(res.data.data[0].emaillist);
                setEmail(res.data.data[0].email)
                setPhoneNo(res.data.data[0].phone_no)
                setAddress(res.data.data[0].address);
                setCity(res.data.data[0].city_name);
                setState(res.data.data[0].state_name);
                setZipcode(res.data.data[0].zipcode);
                setLocationName(res.data.data[0].address);
                setSslno(res.data.data[0].ssl_no);
                setMyProfileObj(res.data.data[0]);
                console.log("setMyProfileObj", res.data.data[0]);
                setSellerId(res.data.data[0].seller_id)
                setStatusColor(res.data.data[0].color)

                setCreate_user(res.data.data[0].create_user)
                setCounter_bid(res.data.data[0].counter_bid)
                setUser(res.data.data[0].user_list)

                setPost_car(res.data.data[0].post_car)
                setRemove_car(res.data.data[0].remove_car)
                setPriviegesId(res.data.data[0].seller_privileges_id)
                setImage(res.data.data[0].image);
                formatPhone(res.data.data[0].phonenolist.map(data => data))

                setPrivilegesObj({

                    createUser: res.data.data[0].create_user,
                    counterBid: res.data.data[0].counter_bid,
                    postCar: res.data.data[0].post_car,
                    removeCar: res.data.data[0].remove_car,
                    user_list: res.data.data[0].user_list


                })

                setIsPrivileges(sellerDetails.seller_id === res.data.data[0].seller_id ? false : true)
                if (res.data.data[0].create_user == 1 && res.data.data[0].counter_bid == 1 && res.data.data[0].post_car == 1 && res.data.data[0].user_list == 1 &&
                    res.data.data[0].remove_car == 1) {
                    setselectPrivilege(true)
                    setDeselectPrivilege(false)
                } else if (res.data.data[0].create_user == 0 && res.data.data[0].counter_bid == 0 && res.data.data[0].post_car == 0 && res.data.data[0].user_list == 0 &&
                    res.data.data[0].remove_car == 0) {
                    setselectPrivilege(false)
                    setDeselectPrivilege(true)
                } else {
                    setselectPrivilege(false)
                    setDeselectPrivilege(false)
                }
                setLoading(false);
            }
            else {
                setErrors(res.data.error)
                setErrorFlag(true)
            }

        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                    setLoading(false);
                }
            });
    }, []);
    function handleOnChange(value) {
        setPrimaryPhone(value);
    }
    function handleOnChanges(value) {
        setMobilephone(value);
    }
    function formatPhone(value) {
        let i = 0;
        for (i = 0; i < value.phone_no?.length; i++) {
            var x = 0;
            x = value.phone_no[i].replace(/\D/g, "").match(/(\d{3})(\d{3})(\d{4})/);
            value.phone_no[i] = "+1" + "(" + x[1] + ")" + x[2] + "-" + x[3];
        }
        return setPrimaryPhone(value?.map((data, index) => { return { ...data, "id": `phoneNo${index}`, "phone_no": data.phone_no } }))
    }

    const handleInput = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
        }
    }
    const MaskedSSN = (ssn) => {
        const lastFourDigits = ssn.slice(-4);
        const maskedSSN = '*****' + lastFourDigits;
        return maskedSSN;
    };
    return (
        <div>

            {loading ? <Loading /> :
                <main id="main" className="inner-page">

                    {errorFlag === true ? <PageNotFound error={errors} /> :
                        <div className="editprofile">
                            <div className="container-fluid inner-page-space" >
                                <div className="adduserpageblock col-lg-12">
                                    <div className="section-title">
                                        <h2>Seller</h2>
                                    </div>
                                    <div className="row content">
                                        <div className="col-lg-4 col-md-12 col-sm-12 mgaccountleftblock">

                                            <ManageAccountLinks />
                                        </div>

                                        <div className="col-lg-8 col-md-12 col-sm-12 mgaccountrightblock">
                                            <div className="col-lg-12 myprofileeditform">
                                                <form className="registrationform"  >
                                                    <div className="section-title">
                                                        <button className="back-btn-paymentform backBtn" onClick={() => history.push("/seller")}><i className="icofont-arrow-left"></i> Back</button>
                                                        <h2>View Seller</h2>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-12 form-group view-img">
                                                            <div className="user-upload-btn-wrapper">
                                                                {doc === "" ? <img alt="" src={myProfileObjc.image || adduser} ></img> :
                                                                    <img alt="" src={doc.base64} ></img>
                                                                }

                                                            </div>
                                                        </div>

                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" className={sellerId != "" ?
                                                                    statusColor == "pink"
                                                                        ? "tableRowPink  textbox"
                                                                        : statusColor == "Silver"
                                                                            ? "tableRowSilver  textbox"
                                                                            : statusColor == "Orange"
                                                                                ? "tableRowOrange  textbox"
                                                                                : statusColor == "Navy blue"
                                                                                    ? "tableRowNavyBlue  textbox"
                                                                                    : statusColor == "firered"
                                                                                        ? "tableRowFireRed  textbox"
                                                                                        : statusColor == "Purple"
                                                                                            ? "tableRowPurple  textbox"
                                                                                            : statusColor == "Yellow"
                                                                                                ? "tableRowYellow1  textbox"
                                                                                                : statusColor == "green"
                                                                                                    ? " tableRowGreenColor textbox "
                                                                                                    : statusColor == "blue"
                                                                                                        ? "tableRowBlue  textbox"
                                                                                                        : statusColor == "darkred"
                                                                                                            ? "tableRowRed1  textbox"
                                                                                                            : statusColor == "black"
                                                                                                                ? "tableRowBlack1  textbox"
                                                                                                                : "form-control textbox" : ""} placeholder="" value={myProfileObjc.seller_id}
                                                                    disabled />
                                                                <label htmlFor="seller_id" className={sellerId != "" ? "input-has-value" : ""}>Seller #</label>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" defaultValue={myProfileObjc.first_name} className="form-control textbox" placeholder="" disabled />
                                                                <label htmlFor="first_name" className={firstName != "" ? "input-has-value" : ""}>First Name</label>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" defaultValue={myProfileObjc.last_name} className="form-control textbox" placeholder="" disabled />
                                                                <label htmlFor="last_name" className={lastName != "" ? "input-has-value" : ""}>Last Name</label>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" className={
                                                                    statusColor == "pink"
                                                                        ? "tableRowPink  textbox"
                                                                        : statusColor == "Silver"
                                                                            ? "tableRowSilver  textbox"
                                                                            : statusColor == "Orange"
                                                                                ? "tableRowOrange  textbox"
                                                                                : statusColor == "Navy blue"
                                                                                    ? "tableRowNavyBlue  textbox"
                                                                                    : statusColor == "firered"
                                                                                        ? "tableRowFireRed  textbox"
                                                                                        : statusColor == "Purple"
                                                                                            ? "tableRowPurple  textbox"
                                                                                            : statusColor == "Yellow"
                                                                                                ? "tableRowYellow1  textbox"
                                                                                                : statusColor == "green"
                                                                                                    ? " tableRowGreenColor textbox  "
                                                                                                    : statusColor == "blue"
                                                                                                        ? "tableRowBlue  textbox"
                                                                                                        : statusColor == "darkred"
                                                                                                            ? "tableRowRed1  textbox"
                                                                                                            : statusColor == "black"
                                                                                                                ? "tableRowBlack1  textbox"
                                                                                                                : " form-control textbox"}
                                                                    value={selectedStatus}
                                                                    placeholder="" disabled />
                                                                <label htmlFor="first_name" className={statusColor != "" ? "input-has-value" : ""}>Seller Status</label>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-4 form-group countrycode">
                                                            <div className="tbox">
                                                                <input
                                                                    type="text"
                                                                    class="form-control"
                                                                    id="extentation1"
                                                                    value={myProfileObjc?.country_code}
                                                                    disabled
                                                                />
                                                                <label for="drop" className={"input-has-value"}>Country Code</label>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-5 form-group ">

                                                            <div className="tbox ">
                                                                <PhoneInputs
                                                                    className="textbox"
                                                                    country={'us'}
                                                                    disableDropdown={true}
                                                                    disableCountryCode={true}
                                                                    onlyCountries={['us']}
                                                                    value={phoneNo}
                                                                    placeholder=""
                                                                    disabled
                                                                ></PhoneInputs>
                                                                <label for="phone_no" className={phoneNo != "" ? "input-has-value" : ""}>Primary Phone #</label>
                                                            </div>

                                                            <p className="form-input-error" >{primaryPhoneError}</p>
                                                        </div>
                                                        <div className="col-sm-3 form-group">
                                                            <div className="tbox ">
                                                                <input
                                                                    type="text"
                                                                    class="form-control"
                                                                    id="extentation1"
                                                                    value={myProfileObjc.extentation}
                                                                    disabled
                                                                />
                                                                <label for="drop" className={"input-has-value"}>Extension</label>

                                                            </div>
                                                        </div>

                                                        <div className="col-sm-4 form-group countrycode">
                                                            <div className="tbox">
                                                                {primaryPhone.length > 0 ? primaryPhone.map((data) =>
                                                                    <>
                                                                        <div className="">
                                                                            <input
                                                                                type="text"
                                                                                class="form-control"
                                                                                id="extentation12"
                                                                                value={data?.country_code}
                                                                                disabled
                                                                            />
                                                                            <label for="drop" className={"input-has-value"}>Country Code</label>
                                                                        </div>
                                                                    </>) : ""}
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-5 form-group ">
                                                            <div className="tbox ">
                                                                {primaryPhone.length > 0 ? primaryPhone.map((data, index) =>
                                                                    <>
                                                                        <PhoneInputs
                                                                            className="textbox"
                                                                            country={'us'}
                                                                            disableDropdown={true}
                                                                            disableCountryCode={true}
                                                                            onlyCountries={['us']}
                                                                            value={data.phone_no}
                                                                            disabled
                                                                            placeholder=""
                                                                        ></PhoneInputs>
                                                                        <label htmlFor={`phoneNo${index}`} className={data != "" ? "input-has-value" : ""}>Alternate Phone #</label>

                                                                    </>) : ""}
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-3 form-group">
                                                            <div className="tbox ">
                                                                {primaryPhone.length > 0 ? primaryPhone.map((data, index) =>
                                                                    <>
                                                                        <input
                                                                            type="text"
                                                                            class="form-control"
                                                                            id="extentation1"
                                                                            value={data.extentation}
                                                                            disabled
                                                                        />
                                                                        <label for="drop" className={"input-has-value"}>Extension</label>
                                                                    </>) : ""}

                                                            </div>
                                                        </div>



                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" defaultValue={myProfileObjc.email} className="form-control textbox" placeholder="" disabled />
                                                                <label htmlFor="address" className={email != "" ? "input-has-value" : ""}>Primary Email</label>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                {emailId.length > 0 ? emailId.map((data, index) =>
                                                                    <>
                                                                        <input type="email" defaultValue={data.email} className="form-control textbox" placeholder="" disabled />
                                                                        <label htmlFor={`email${index}`} className={data.email != "" ? "input-has-value" : ""}>Alternative Email</label>
                                                                    </>
                                                                ) : ""}
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input className="form-control textbox " type="text" placeholder="" id="new-ssl" maxLength="300" name="slnumber" disabled
                                                                    defaultValue={myProfileObjc?.ssl_no === null || myProfileObjc?.ssl_no === undefined || myProfileObjc?.ssl_no === "" ? "" : `${MaskedSSN(myProfileObjc?.ssl_no)}`} />

                                                                <label htmlFor="new-ssl" className={sslNo != "" ? "input-has-value" : ""}>SSN #</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" defaultValue={myProfileObjc.address} className="form-control textbox" placeholder="" disabled />
                                                                <label htmlFor="address" className={address != "" ? "input-has-value" : ""}>Address</label>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-4 form-group">
                                                            <div className="tbox">
                                                                <input type="text" defaultValue={myProfileObjc?.state_name} className="form-control textbox" placeholder="" disabled />
                                                                <label htmlFor="address" className={address != "" ? "input-has-value" : ""}>State</label>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-4 form-group">
                                                            <div className="tbox">
                                                                <input type="text" defaultValue={myProfileObjc?.city_name} className="form-control textbox" placeholder="" disabled />
                                                                <label htmlFor="address" className={address != "" ? "input-has-value" : ""}>City</label>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-4 form-group">
                                                            <div className="tbox">
                                                                <input type="text" defaultValue={myProfileObjc?.zipcode} className="form-control textbox" placeholder="" disabled />
                                                                <label htmlFor="address" className={address != "" ? "input-has-value" : ""}>Zip Code</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-12 form-group">
                                                            <div className="tbox">
                                                                <input type="text" defaultValue={myProfileObjc.address} className="form-control textbox" placeholder="" disabled />
                                                                <label htmlFor="address" className={locationName != "" ? "input-has-value" : ""}>Location Name</label>
                                                            </div>
                                                        </div>
                                                        {isPrivileges && <div>
                                                            <div className="section-title">
                                                                <h2 className="buyertitle">Seller Privileges</h2>
                                                            </div>
                                                            <div className="col-sm-12">
                                                                <div className="radio input-group privileges">
                                                                    <input id="radio-privileges" name="radio" type="radio" value="1" checked={selectPrivilege} />
                                                                    <label htmlFor="radio-privileges" className="radio-label">Select Seller Privileges</label>
                                                                </div>
                                                                <div className=" row adduserpageforminner">
                                                                    <div className="col-sm-6 form-group input-group">
                                                                        <input type="checkbox" id="post_car" disabled={deselectPrivilege} value={post_car == 0 ? 1 : 0} checked={post_car == 1 ? true : false} />
                                                                        <label htmlFor="post_car">post car</label>
                                                                    </div>
                                                                    <div className="col-sm-6 form-group input-group ">
                                                                        <input type="checkbox" id="remove_car" disabled={deselectPrivilege} value={remove_car == 0 ? 1 : 0} checked={remove_car == 1 ? true : false} />
                                                                        <label htmlFor="remove_car">Remove car</label>
                                                                    </div>

                                                                    <div className="col-sm-6 form-group input-group ">
                                                                        <input type="checkbox" id="counterbid" disabled={deselectPrivilege} value={counter_bid == 0 ? 1 : 0} checked={counter_bid == 1 ? true : false} />
                                                                        <label htmlFor="counterbid">Counterbid</label>
                                                                    </div>
                                                                    <div className="col-sm-6 form-group input-group ">
                                                                        <input type="checkbox" id="counterbid" disabled={deselectPrivilege} value={user == 0 ? 1 : 0} checked={user == 1 ? true : false} />
                                                                        <label htmlFor="counterbid">User</label>
                                                                    </div>
                                                                    {user == 1 ?
                                                                        <div className="col-sm-6 form-group input-group ">
                                                                            <input type="checkbox" id="createuser" disabled={deselectPrivilege} value={create_user == 0 ? 1 : 0} checked={create_user == 1 ? true : false} />
                                                                            <label htmlFor="createuser">Createuser</label>
                                                                        </div>
                                                                        : ""}
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12">
                                                                <div className="radio input-group noprivileges">
                                                                    <input id="radio-noprivileges" name="radio" type="radio" value="0" checked={deselectPrivilege} />
                                                                    <label htmlFor="radio-noprivileges" className="radio-label">No privileges (Only View)</label>
                                                                </div>
                                                            </div>
                                                        </div>}
                                                        <div className="col-lg-12 loginBtn">
                                                        </div>
                                                    </div>
                                                </form>
                                            </div></div></div></div></div></div>}
                    <section id="playstoreBlock" className="playstoreBlock">
                        <div className="container">
                            <div className="row content">
                                <div className="col-lg-12">
                                    <img src={appstore} />
                                    <img src={googleplay} />
                                </div>
                            </div>
                        </div>
                    </section>

                </main>
            }
        </div>
    )
}

export default EditSeller;